// header.js
;(() => {
    const header = document.querySelector('#header')
    const stickedClass = 'header--sticked'

    const updateHeader = () => {
        const top = header.getBoundingClientRect().top
        if (top === 0) {
            header.classList.add(stickedClass)
        } else {
            header.classList.remove(stickedClass)
        }
    }

    updateHeader()

    window.addEventListener('scroll', updateHeader)
})();